// load scss
import './Main.scss';

// load svg sprite
import loadSpriteSvgs from './Component/Sprite/LoadSprite';
loadSpriteSvgs();

import './General/Lib/CreateNamespace';
import './Document/Search/Fragments/SearchForm';
import 'swipebox/src/js/jquery.swipebox.js';
import 'slick-carousel/slick/slick.min.js';
import './Content/Video/Video';

import 'Packages/Plugins/GesagtGetan.Inquiry/Resources/Public/JavaScript/SpamProtection';

function initElipsis() {
    $("td .description").each(function () {
        text = $(this).text();
        if (text.length > 250) {
            $(this).html(text.substr(0, 186) + '<span class="elipsis">' + text.substr(186) + '</span><a class="elipsis" href="#">...</a>');
        }
    });
    $("td .description > a.elipsis").click(function (e) {
        e.preventDefault();
        $(this).prev('span.elipsis').fadeToggle(500);
    });
}

function initSwipebox() {
    $('.swipebox').swipebox();
}

function initForms() {
    var Forms = {
        init: function () {
            Forms.clickHandlers();
        },

        clickHandlers: function () {
            $('.formContainer').on('click', '.jsClose', function () {
                $('.formContainer').fadeOut('slow', function () {
                    Forms.resetForm();
                    $('body').css('overflow', 'auto');
                });
            });

            $('.jsContactButton').click(function () {
                $('.formContainer__contactForm').fadeIn();
                $('#contactForm-userid').val($(this).data('nodeid'));
                $('body').css('overflow', 'hidden');
            });
        },

        resetForm: function () {
            $('#contactForm').show();
        }
    }

    Forms.init();
}

const form = document.querySelector('.contactForm, .eventForm');

if(form) { 
    floatingLabel(form.querySelectorAll('input,textarea'));
}

function floatingLabel(fields) {
    [...fields].forEach((field) => {
        const label = document.querySelector(`[for=${field.id}]`);

        if(document.getElementById(field.id).value == '') {
            label.classList.add('idle')
        }

        field.addEventListener('focus', () => {
            field.classList.contains('visited')? '':field.classList.add('visited'), label.classList.remove('idle');
            field.addEventListener('blur', () => {
                field.value !== ''? '':label.classList.add('idle'), field.classList.remove('visited');
            });
        });
    });
}

function initCountdown() {
    var Countdown = {
        init: function () {
            var elements = document.querySelectorAll('.js-countdown');
            for (let index = 0; index < elements.length; index++) {
                Countdown.setup(elements[index]);
            }
        },

        getTimeRemaining: function (endtime) {
            var t = Date.parse(endtime) - Date.parse(new Date());
            var seconds = Math.floor((t / 1000) % 60);
            var minutes = Math.floor((t / 1000 / 60) % 60);
            var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
            var days = Math.floor(t / (1000 * 60 * 60 * 24));
            return {
                'total': t,
                'days': days,
                'hours': hours,
                'minutes': minutes,
                'seconds': seconds
            };
        },
        setup: function (clock) {
            var endtime = clock.getAttribute('data-deadline');
            var daysDiv = clock.querySelector('.countdown__days');
            var hoursDiv = clock.querySelector('.countdown__hours');
            var minutesDiv = clock.querySelector('.countdown__minutes');
            var secondsDiv = clock.querySelector('.countdown__seconds');
            var daysLabel = clock.querySelector('.countdown__label--days');
            var hoursLabel = clock.querySelector('.countdown__label--hours');
            var minutesLabel = clock.querySelector('.countdown__label--minutes');
            var secondsLabel = clock.querySelector('.countdown__label--seconds');
            var interval = null;

            function update() {
                var t = Countdown.getTimeRemaining(endtime);

                daysDiv.innerHTML = t.days;
                hoursDiv.innerHTML = ('0' + t.hours).slice(-2);
                minutesDiv.innerHTML = ('0' + t.minutes).slice(-2);
                secondsDiv.innerHTML = ('0' + t.seconds).slice(-2);

                if (t.days === 1) {
                    daysLabel.innerHTML = ('Tag');
                } else {
                    daysLabel.innerHTML = ('Tage');
                }
                if (t.hours === 1) {
                    hoursLabel.innerHTML = ('Stunde');
                } else {
                    hoursLabel.innerHTML = ('Stunden');
                }
                if (t.minutes === 1) {
                    minutesLabel.innerHTML = ('Minute');
                } else {
                    minutesLabel.innerHTML = ('Minuten');
                }
                if (t.seconds === 1) {
                    secondsLabel.innerHTML = ('Sekunde');
                } else {
                    secondsLabel.innerHTML = ('Sekunden');
                }

                if (t.total <= 0) {
                    clearInterval(interval);
                }
            }
            update();
            interval = setInterval(update, 1000);
        }
    };

    Countdown.init();
}

function initSlickSlider() {
    if ($('.slider').length) {
        $('.slider').slick({
            autoplay: !window.matchMedia('(prefers-reduced-motion: reduce)').matches,
            autoplaySpeed: 4000,
        });
    }
}

$(function() {
    initElipsis();
    initSwipebox();
    initForms();
    initCountdown();
    initSlickSlider();

    //improved touch support for news teaser
    $('.latestNewsItem').on('touchstart', function () {
        $(this).click();
    });
});
